import { getDisplayLocale } from "../../utils/timezoneUtils";

/** A UTC instant as the viewer's local date and time in the app language, e.g. "28.10.2026, 09:14" in de. */
export const formatAdminTimestamp = (date: Date, locale: string = getDisplayLocale()): string =>
  new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(date);
